import { useEffect } from "react";

export default function DocumentTitle(props: { children: string }) {
  useEffect(() => {
    document.title = props.children;
  }, [props.children]);

  return null;
}
